import {
	Box,
	VStack,
	Text,
	useBreakpointValue,
	Stack,
} from 'native-base'
import useCommonResponsiveValues from 'app/hooks/useCommonResponsiveValues'

// constant
import colors from 'app/colors'
import DiagnosticScreen from 'app/features/main/components/DiagnosticScreen'

const IntroSection2 = () => {
	const { containerWidth } = useCommonResponsiveValues()

	const text1Props = useBreakpointValue({
		lg: {
			fontSize: '50px',
			fontWeight: 900,
			lineHeight: '70px',
		},
		base: {
			size: 'h3/800',
		},
	})

	const gap1 = useBreakpointValue({
		lg: '60px',
		base: '16px',
	})

	return (
		<Box backgroundColor="singletons.white" alignItems="center">
			<VStack
				w={containerWidth}
				alignItems="center"
				py={{ base: '48px', lg: '120px' }}
			>
				<Stack
					px={{ base: '16px', lg: '24px' }}
					py={{ base: '4px', lg: '8px' }}
					borderRadius="60px"
					borderWidth="2px"
					borderColor={colors.grey800}
				>
					<Text
						size={useBreakpointValue({
							base: 'p_s/600',
							lg: 'h5/600',
						})}
					>
						현재 아이의 상태를 파악하고 분석한
					</Text>
				</Stack>
				<Text
					textAlign="center"
					mt={{ base: '12px', lg: '24px' }}
					{...text1Props}
					color={colors.black}
				>
					{'종합학습진단 결과지'}
				</Text>
				<Box height={gap1} />
				<DiagnosticScreen />
			</VStack>
		</Box>
	)
}

export default IntroSection2
